import { useContext } from "react";
import { Grid } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { LocaleContext } from "../../../../routing/LangRouter";

//styles
import "../../user-panel/panel-menu/panel-menu.scss";

//icons
import { Profile } from "iconsax-react";

function AdminPanelMenu() {
    const location = useLocation();
    const { locale, setLocale } = useContext(LocaleContext);

    return (
        <Grid item xs={12}>
            <nav className="panel-menu__menu">
                <ul className="panel-menu__menu-list">
                    <li className={`panel-menu__menu-item ${location.pathname === `/${locale}/admin-panel/locations-managment` ? "active" : ""}`}>
                        <Link
                            className={`panel-menu__menu-link ${
                                location.pathname === `/${locale}/admin-panel/locations-managment` ? "active-link" : ""
                            }`}
                            to="locations-managment"
                        >
                            <img
                                src={
                                    location.pathname === `/${locale}/admin-panel/locations-managment` ? (
                                        <Profile color="var(--light-color)" variant="Bold" />
                                    ) : (
                                        <Profile color="var(--teal-color-18)" />
                                    )
                                }
                                alt=""
                            ></img>
                            لوکیشن ها
                        </Link>
                    </li>
                    <li className={`panel-menu__menu-item ${location.pathname === `/${locale}/admin-panel/information` ? "active" : ""}`}>
                        <Link
                            className={`panel-menu__menu-link ${location.pathname === `/${locale}/admin-panel/information` ? "active-link" : ""}`}
                            to="information"
                        >
                            <img
                                src={
                                    location.pathname === `/${locale}/admin-panel/information` ? (
                                        <Profile color="var(--light-color)" variant="Bold" />
                                    ) : (
                                        <Profile color="var(--teal-color-18)" />
                                    )
                                }
                                alt=""
                            ></img>
                            اطلاعات
                        </Link>
                    </li>
                </ul>
            </nav>
        </Grid>
    );
}

export default AdminPanelMenu;
